/**
 * Read-only artifact viewer state.
 *
 * The document / spreadsheet / presentation EDITORS live in the contextual
 * sidebar, which only mounts on desktop web. Phones and native therefore had
 * no way to look at a generated deck or workbook in-app at all — tapping the
 * attachment handed the file straight to the OS. This store drives a
 * full-screen read-only viewer for those platforms, mirroring the lightbox
 * (its own store plus a root host) rather than the modal system, whose native
 * presentation is a partial-height bottom sheet.
 *
 * Leaf module: no api/socket/store-barrel imports, so `constants/utils/files`
 * can open the viewer without pulling in the store monolith.
 */
import { create } from 'zustand';

const CLOSED = { isOpen: false, kind: null, file: null };

export const useArtifactViewerStore = create((set) => ({
  ...CLOSED,

  /**
   * @param {'presentation'|'pptx'|'spreadsheet'|'document'|'code'|'pdf'|'video'|'video-project'} kind
   * @param {object} file serialized File carrying the spec (or Markdown
   *   source, for documents) in `parameters`, or studio props for video-project
   */
  openArtifactViewer: (kind, file) => {
    if (!kind || !file) return;
    set({ isOpen: true, kind, file });
  },

  closeArtifactViewer: () => set({ ...CLOSED }),
}));
